import { RouteConfig } from "vue-router";

const routes: Array<RouteConfig> = [
  {
    path: "mapVisualization",
    name: "mapVisualization",
    component: () => import("./components/web/index-web.vue"),
    meta: { title: "Visualizzazione in Mappa", showExpander: false, requireAuth: false }
  },
];

export default routes;